module.exports = "<Badge badgeContent={4} primary={true}>\n  <NotificationsIcon />\n</Badge>\n\n//override badgeStyle to account for padding of child element\n<Badge badgeContent={10} secondary={true} badgeStyle={{top:12, right:12}}>\n  <IconButton tooltip=\"Go To Cart\">\n    <ShoppingCartIcon/>\n  </IconButton>\n</Badge>\n\n<Badge backgroundColor=\"#d8d8d8\"\n       badgeContent={<IconButton tooltip=\"Backup\"><UploadIcon/></IconButton>}>\n  <FolderIcon />\n</Badge>\n\n<Badge badgeContent=\"&copy;\" badgeStyle={{fontSize:20}}>\n  <h3>Company Name</h3>\n</Badge>"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/raw-code/badge-code.txt
 ** module id = 775
 ** module chunks = 0
 **/